var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length)?_c('div',{staticClass:"custom-fields",class:['custom-fields--length-' + _vm.items.length]},_vm._l((_vm.items),function(item){return _c('Field',_vm._g({key:item.key,attrs:{"value":_vm.get(item.key),"schema":item}},{
      ..._vm.$listeners,
      input: $ev => _vm.onInput($ev, item),
      remove: $ev => _vm.$emit('remove', $ev),
    }))}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }